import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DividerModule } from 'primeng/divider';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MessageModule } from 'primeng/message';
import { PasswordModule } from 'primeng/password';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { ProgressBarModule } from 'primeng/progressbar';
import { ActivationComponent } from './activation/activation.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { LostPasswordComponent } from './lost-password/lost-password.component';
import { NewPasswordComponent } from './new-password/new-password.component';
import { RegisterComponent } from './register/register.component';
import { RegisterFinishedComponent } from './register-finished/register-finished.component';
import { ToastModule } from 'primeng/toast';
import { TranslateModule } from '@ngx-translate/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AuthPageComponent } from '@/pages/auth-page.component';
import { RouterLink, RouterOutlet } from '@angular/router';
import { InputTextModule } from 'primeng/inputtext';
import { Checkbox } from 'primeng/checkbox';
import { AutofocusDirective } from '@/common/directives/autofocus.directive';

@NgModule({
    declarations: [
        ActivationComponent,
        LoginComponent,
        LogoutComponent,
        LostPasswordComponent,
        NewPasswordComponent,
        RegisterComponent,
        RegisterFinishedComponent,
        AuthPageComponent,
        AutofocusDirective,
    ],
    imports: [
        ToastModule,
        DividerModule,
        FormsModule,
        MessageModule,
        PasswordModule,
        ButtonModule,
        SelectModule,
        ProgressBarModule,
        CommonModule,
        TranslateModule,
        ProgressSpinnerModule,
        RouterOutlet,
        ReactiveFormsModule,
        InputTextModule,
        RouterLink,
        Checkbox,
    ],
    exports: [],
})
export class PagesModule {}
